import { HelpCircle, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "@/components/NotificationBell";
import { TopSearch } from "@/components/layout/TopSearch";
import { hasGuide } from "@/tours/guides";
import { GuideMenu } from "@/components/layout/GuideMenu";

/** Top right corner of the top bar: notifications, who is signed in, and log out. */
export function TopUser({ moduleId }) {
  const { user, logout } = useAuth();
  const initials = (user?.full_name || "U").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div data-testid="topbar-user" className="ml-auto flex shrink-0 items-center gap-2.5">
      <TopSearch />
      <NotificationBell compact variant="topbar" />
      {hasGuide(moduleId) && <GuideMenu moduleId={moduleId} />}
      <button type="button" data-testid="take-tour-button" data-tour="take-tour" title="Take a tour" aria-label="Take a tour"
        onClick={() => window.dispatchEvent(new Event("buildnexa:start-tour"))}
        className="hidden h-7 shrink-0 items-center gap-1.5 rounded-lg bg-[#454D5C] px-2.5 text-xs font-medium text-[#ECF4F7]/80 transition-colors hover:bg-[#4A5260] hover:text-[#ECF4F7] md:flex">
        <HelpCircle className="h-3.5 w-3.5" /> <span className="hidden xl:inline">Take a tour</span>
      </button>
      <span className="hidden h-6 w-px bg-[#4A5260] sm:block" />
      <span title={user?.full_name} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#910029] text-xs font-bold text-white">{initials}</span>
      <div className="hidden min-w-0 max-w-[160px] sm:block">
        <p className="truncate text-[12px] font-semibold leading-tight text-[#ECF4F7]" data-testid="current-user-name">{user?.full_name}</p>
        <p className="truncate text-[10px] font-medium leading-tight text-[#C4587B]" data-testid="current-user-role">{user?.role}</p>
      </div>
      <button data-testid="logout-button" onClick={logout} title="Log out" aria-label="Log out"
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#454D5C] text-[#8B9BB8] transition-colors hover:bg-[#910029] hover:text-white">
        <LogOut className="h-4 w-4" />
      </button>
    </div>
  );
}
